
/*
 * GABADINI SLEEP — CAMPAIGN NAVIGATION
 * Returns active campaign visitors to their offers.
 * Does not modify cart, discounts or selling plans.
 */

(() => {
  'use strict';

  const selector = '[data-gabadini-continue-shopping]';

  function destination() {
    const active =
      window.GabadiniCampaignIdentity?.getActive?.();

    const path = active === 'FIRE50'
      ? 'pages/sleep50'
      : 'pages/sleep-solutions';

    const root = window.Shopify?.routes?.root || '/';

    return (root.endsWith('/') ? root : root + '/') + path;
  }

  function updateLink(link) {
    if (link) link.setAttribute('href', destination());
  }

  function updateAll() {
    document.querySelectorAll(selector).forEach(updateLink);
  }

  function updateFromEvent(event) {
    const target = event.target;

    if (!(target instanceof Element)) return;

    updateLink(target.closest(selector));
  }

  // Works with cart elements recreated by Dwell.
  ['pointerover', 'focusin', 'click', 'auxclick', 'contextmenu']
    .forEach(type => {
      document.addEventListener(
        type,
        updateFromEvent,
        true
      );
    });

  document.addEventListener(
    'shopify:section:load',
    updateAll
  );

  document.addEventListener(
    'gabadini:campaign-expired',
    updateAll
  );

  window.addEventListener('pageshow', updateAll);

  window.addEventListener('storage', updateAll);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateAll,
      { once: true }
    );
  
  } else {
    updateAll();
  }

  // Add a return link above Purchase Options
  // for visitors with an active FIRE50 campaign.
  function updateProductReturnLink() {
    const active =
      window.GabadiniCampaignIdentity?.getActive?.() === 'FIRE50';

    // Remove links when the campaign expires
    // or when their Purchase Options block is replaced.
    document.querySelectorAll(
      '[data-gabadini-product-return]'
    ).forEach(link => {
      if (
        !active ||
        !link.nextElementSibling?.matches(
          '[data-gabadini-product-handle]'
        )
      ) {
        link.remove();
      }
    });

    if (!active) return;

    document.querySelectorAll(
      '[data-gabadini-product-handle]'
    ).forEach(block => {
      if (
        block.previousElementSibling?.matches(
          '[data-gabadini-product-return]'
        )
      ) return;

      const link = document.createElement('a');

      link.setAttribute(
        'data-gabadini-product-return',
        ''
      );

      link.href = destination();
      link.textContent =
        '← Back to Fire Services offers';

      link.style.cssText = [
        'display: inline-block',
        'margin: 0 0 12px',
        'font-size: 13px',
        'color: inherit',
        'text-decoration: underline',
        'text-underline-offset: 3px'
      ].join(';');

      block.before(link);
    });
  }

  document.addEventListener(
    'shopify:section:load',
    updateProductReturnLink
  );

  document.addEventListener(
    'gabadini:campaign-expired',
    updateProductReturnLink
  );

  window.addEventListener(
    'pageshow',
    updateProductReturnLink
  );

  window.addEventListener(
    'focus',
    updateProductReturnLink
  );

  window.addEventListener(
    'storage',
    updateProductReturnLink
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateProductReturnLink,
      { once: true }
    );
  } else {
    updateProductReturnLink();
  }
})();

